<!-- Google Maps Script -->
    var map;
    var markers = [];
    var locations = [
            {
              "title": "FairPrice Finest Jewel Changi Airport",
              "address1": "78 Airport Boulevard, Jewel, #B2-205/206 Singapore Changi Airport, 207/208, Singapore 819666",
              "lat": 1.3600245,
              "lng": 103.9902708
            },
            {
              "title": "FairPrice Finest T3 Changi Airport",
              "address1": "65 Airport Blvd., B2-10 Singapore Changi Airport, Terminal 3, Singapore 819663",
              "lat": 1.3555805,
              "lng": 103.9861962
            },
            {
              "title": "FairPrice Finest Bedok Mall",
              "address1": "311 New Upper Changi Road B2, #60, Singapore 467360",
              "lat": 1.3244384,
              "lng": 103.9286889
            },
            {
              "title": "FairPrice Finest Marine Parade Central",
              "address1": "6 Marine Parade Central, Singapore 449411",
              "lat": 1.3014643,
              "lng": 103.9071125
            },
            {
              "title": "FairPrice Finest Katong Village",
              "address1": "30 East Coast Road, #01-06/07/08/09, Katong V, Singapore 428751",
              "lat": 1.3039513,
              "lng": 103.9028164
            },
            {
              "title": "FairPrice Finest Paya Lebar Quarter",
              "address1": "10 Paya Lebar Rd, #B2-09 PLQ Mall, Singapore 409057",
              "lat": 1.3175284,
              "lng": 103.8928037
            },
            {
              "title": "FairPrice Finest Waterway Point",
              "address1": "83 Punggol Central, #B2-32 Waterway Point, Singapore 828761",
              "lat": 1.4064412,
              "lng": 103.9020846
            },
            {
              "title": "FairPrice Finest The Woodleigh Mall",
              "address1": "11 Bidadari Park Drive, Mall, B1-32/33 The Woodleigh, Singapore 367803",
              "lat": 1.3385007,
              "lng": 103.8716089
            },
            {
              "title": "FairPrice Finest Causeway Point",
              "address1": "1 Woodlands Square, #B1-31/32/33 Causeway Point, Singapore 738099",
              "lat": 1.4362048,
              "lng": 103.7857208
            },
            {
              "title": "FairPrice Finest Seletar Mall",
              "address1": "33 Sengkang West Ave, #B2 - 24, Singapore 797653",
              "lat": 1.3911823,
              "lng": 103.8760126
            },
            {
              "title": "FairPrice Finest Serangoon Garden myVillage",
              "address1": "1 Maju Avenue, #B1-11/12/13/14/19/K8/K9, myVillage, Singapore 556679",
              "lat": 1.3650428,
              "lng": 103.8651508
            },
            {
              "title": "FairPrice Finest Junction 8",
              "address1": "9 Bishan Pl, #B1-01 Junction 8, Singapore 579837",
              "lat": 1.3510259,
              "lng": 103.8489515
            },
            {
              "title": "FairPrice Finest Ang Mo Kio Blk 712",
              "address1": "712 Ang Mo Kio Ave 6, #01-4056, Singapore 560712",
              "lat": 1.3714127,
              "lng": 103.8470787
            },
            {
              "title": "FairPrice Finest Zhong Shan Park",
              "address1": "20 Ah Hood Rd, #02-01 Zhongshan Mall, Singapore 329984",
              "lat": 1.3270623,
              "lng": 103.8464807
            },
            {
              "title": "FairPrice Finest Wisteria Mall",
              "address1": "598 Yishun Ring Rd, #01-01 Wisteria Mall, Singapore 768698",
              "lat": 1.4183983,
              "lng": 103.841277
            },
            {
              "title": "FairPrice Finest Thomson Plaza",
              "address1": "301 Upper Thomson Rd, #03-37/38 Thomson Plaza, Singapore 574408",
              "lat": 1.3547574,
              "lng": 103.8306264
            },
            {
              "title": "FairPrice Finest Amara 100AM",
              "address1": "100 Tras Street, #B1-01, #100AM, Singapore 079027",
              "lat": 1.2750063,
              "lng": 103.8435656
            },
            {
              "title": "FairPrice Finest Valley Point",
              "address1": "491 River Valley Rd, #01 - 14, Singapore 248371",
              "lat": 1.292907,
              "lng": 103.8270208
            },
            {
              "title": "FairPrice Finest Bukit Timah Plaza",
              "address1": "1 Jln Anak Bukit, #B1-01 & #B2-01, Bukit Timah Plaza, 1 Jln Anak Bukit, Singapore 588996",
              "lat": 1.3381781,
              "lng": 103.7782651
            },
            {
              "title": "FairPrice Finest Centrepoint",
              "address1": "176 Orchard Rd, B1 - 09 / 10 The Centrepoint, Singapore 238843",
              "lat": 1.3017287,
              "lng": 103.8395144
            },
            {
              "title": "FairPrice Finest The Woodgrove",
              "address1": "30 Woodlands Ave 1, #01-11 The Woodgrove, Singapore 739065",
              "lat": 1.42895,
              "lng": 103.781124
            },
            {
              "title": "FairPrice Finest The Clementi Mall",
              "address1": "3155 Commonwealth Ave W, B1-12/13/14 The Clementi Mall, Singapore 129588",
              "lat": 1.3151721,
              "lng": 103.7642079
            },
            {
              "title": "FairPrice Finest Bukit Panjang Plaza",
              "address1": "1 Jelebu Rd, #01-15 & #02-20 Bukit Panjang Plaza, Singapore 677743",
              "lat": 1.3803722,
              "lng": 103.7642617
            },
            {
              "title": "FairPrice Finest Le Quest",
              "address1": "4 Bukit Batok Street 41, #01-91/92 Le Quest Shopping Mall, Singapore 657991",
              "lat": 1.3560426,
              "lng": 103.7404547
            },
            {
              "title": "FairPrice Finest Clarke Quay",
              "address1": "3 River Valley Rd, B1-04-05, Singapore 179019",
              "lat": 1.2893232,
              "lng": 103.8315869
            },
            {
              "title": "FairPrice Finest Century Square",
              "address1": "2 Tampines Central 5, #B1-07 Century Square, Singapore 529509",
              "lat": 1.3525968,
              "lng": 103.9410938
            },
            {
              "title": "FairPrice Finest Dairy Farm Residences",
              "address1": "4 Dairy Farm Ln, B1-12 Dairy Farm Mall, Singapore 677622",
              "lat": 1.3660541,
              "lng": 103.7702069
            },
            {
              "title": "FairPrice Finest Sembawang Shopping Centre",
              "address1": "604 Sembawang Rd, #B1-25, Singapore 758459",
              "lat": 1.44168,
              "lng": 103.8224178
            },
            {
              "title": "FairPrice Finest Tiong Bahru Plaza",
              "address1": "302 Tiong Bahru Rd, #B1-122, Singapore 168732",
              "lat": 1.2866255,
              "lng": 103.8240271
            },
            {
              "title": "FairPrice Finest SengKang Grand Mall",
              "address1": "70 Compassvale Bow, B1-14 Sengkang Grand Mall, Singapore 544692",
              "lat": 1.3825507,
              "lng": 103.8896186
            },
            {
              "title": "FairPrice Finest Coronation Plaza",
              "address1": "587 Bukit Timah Rd, #01-01 Coronation Shopping Plaza, Singapore 2697072",
              "lat": 1.3239058,
              "lng": 103.8074115
            },
            {
              "title": "FairPrice Finest 111 Somerset",
              "address1": "111 Somerset Rd, #01-01, TripleOne Somerset, Singapore 238164",
              "lat": 1.3002246,
              "lng": 130.8347406
            },
            {
              "title": "FairPrice Finest Scotts Square",
              "address1": "6 Scotts Road, #B1-03 to 07 & #B1-10 to 12, Singapore 228209",
              "lat": 1.3058518,
              "lng": 103.829846
            },
            {
              "title": "FairPrice Finest Balmoral Plaza",
              "address1": "271 Bukit Timah Road Balmoral Plaza, Balmoral Rd, #01-08 08A, Singapore 259708",
              "lat": 1.3164463,
              "lng": 103.8329371
            },
            {
              "title": "FairPrice Finest Funan Mall",
              "address1": "107 N Bridge Rd, #B1-10 Funan, Singapore 179105",
              "lat": 1.2913919,
              "lng": 103.8475887
            },
            {
              "title": "FairPrice Finest Artra",
              "address1": "12 Alexandra View, #01-18 ARTRA, Singapore 158736",
              "lat": 1.2901524,
              "lng": 103.8145537
            },
            {
              "title": "FairPrice Finest Komo Shoppes",
              "address1": "963C Upper Changi Rd N, #01-01 to 07, Singapore 506790",
              "lat": 1.3603618,
              "lng": 103.9675663
            },
            {
              "title": "FairPrice Finest Yew Tee MRT",
              "address1": "61 Choa Chu Kang Dr, #01-01 MRT Station, Singapore 689715",
              "lat": 1.388475,
              "lng": 103.7344991
            },
            {
              "title": "FairPrice Finest 202 Hougang St 21",
              "address1": "202 Hougang St 21, #01-00, Singapore 530202",
              "lat": 1.3576563,
              "lng": 103.8812627
            },
            {
              "title": "FairPrice Finest Raffles Holland V Mall",
              "address1": "118 Holland Avenue #B1-01 to #B1-13, Raffles Holland V Mall, Singapore 278997",
              "lat": 1.3105313,
              "lng": 103.7935534
            },
            {
              "title": "Fairprice Xtra VivoCity",
              "address1": "1 HarbourFront Walk, #01-23 & #B2-23, 1 HarbourFront Walk, #B2-23 VivoCity, Singapore 098585",
              "lat": 1.2644706,
              "lng": 103.8204516
            },
            {
              "title": "Fairprice Xtra Parkway Parade",
              "address1": "80 Marine Parade Road, #03-28, Parkway Parade, Singapore 449269",
              "lat": 1.301114,
              "lng": 103.902719
            },
            {
              "title": "Fairprice Xtra Changi Business Park",
              "address1": "8 Changi Business Park Avenue 1, #01-51 & #02-51, ESR BizPark@Changi, 486018",
              "lat": 1.3011137,
              "lng": 103.864003
            },
            {
              "title": "Fairprice Xtra Kallang Sport Hub",
              "address1": "1 Stadium Pl, #01 - 29, Singapore 397628",
              "lat": 1.3037048,
              "lng": 103.8705052
            },
            {
              "title": "Fairprice Xtra NEX",
              "address1": "23 Serangoon Central, #03-42 NEX, Singapore 556083",
              "lat": 1.3507155,
              "lng": 103.8694444
            },
            {
              "title": "Fairprice Xtra JEM",
              "address1": "50 Jurong Gateway Road, #B1-21/22 & #B3-01, 50 Jurong Gateway Rd, Jem, Singapore 608549",
              "lat": 1.3335131,
              "lng": 103.7405014
            },
            {
              "title": "Mothercare Harbourfront Centre",
              "address1": "1 Maritime Square, #03-05/06/07, Singapore 099253",
              "lat": 1.2642175,
              "lng": 103.8203582
            },
            {
              "title": "Mothercare Paragon",
              "address1": "290 Orchard Rd, #05 - 24 to 29 Paragon Shopping Centre, Singapore 238859",
              "lat": 1.3039054,
              "lng": 103.8355763
            },
            {
              "title": "Mothercare KK Women's & Children's Hospital",
              "address1": "100 Bukit Timah Rd, #01-11/12/13 KK Hospital, Singapore 229899",
              "lat": 1.3106633,
              "lng": 103.8468054
            },
            {
              "title": "Mothercare Jurong Point",
              "address1": "1 Jurong West Central 2, #02 - 02 / 03 Shopping Centre, Jurong Point, Singapore 648886",
              "lat": 1.3399257,
              "lng": 103.7062886
            },
            {
              "title": "Mothercare Sengkang Grand Mall",
              "address1": "70 Compassvale Bow, #02-08 Singapore 544692",
              "lat": 1.3818947,
              "lng": 103.8901701
            },
            {
              "title": "Mothercare Jewel",
              "address1": "78 AIRPORT BOULEVARD, #04-235/236, JEWEL CHANGI AIRPORT, SINGAPORE 819666",
              "lat": 1.359726,
              "lng": 103.9870085
            },
            {
              "title": "Little Farms Market, Valley Point",
              "address1": "491 River Valley Rd, #01-25, Singapore 248371",
              "lat": 1.2928755,
              "lng": 103.827015
            },
            {
              "title": "Little Farms Market, Katong Point",
              "address1": "451 Joo Chiat Rd, #01-01, Singapore 427664",
              "lat": 1.3069216,
              "lng": 103.9045661
            },
            {
              "title": "Little Farms Market, Guoco Tower",
              "address1": "7 Wallich St, #B2-06 Guoco Tower (formerly Tanjong Pagar Centre, Singapore 078884",
              "lat": 1.2767822,
              "lng": 103.8458608
            },
            {
              "title": "Little Farms Market, Holland Village",
              "address1": "No. 3 Lor Liput, #01-04/05/06 Holland Piazza, Singapore 277725",
              "lat": 1.3107037,
              "lng": 103.795241
            },
            {
              "title": "Little Farms Market, Tanglin Mall",
              "address1": "163 Tanglin Rd, #02-136, Singapore 247933",
              "lat": 1.3050246,
              "lng": 103.8235685
            },
            {
              "title": "Little Farms Market, Serangoon Garden",
              "address1": "1 Maju Ave, #01-12 to 19 myVillage, Singapore 556679",
              "lat": 1.3651312,
              "lng": 103.864971
            },
            {
              "title": "Little Farms Market, Sentosa",
              "address1": "1 Cove Ave, #02-13 Sentosa, Singapore 098537",
              "lat": 1.2469797,
              "lng": 103.8371153
            },
            {
              "title": "CS Fresh Plaza Singapura",
              "address1": "68 Orchard Rd, B2-16, Plaza Singapura, Singapore 238839",
              "lat": 1.3007111,
              "lng": 103.8423237
            },
            {
              "title": "Cold Storage Takashimaya",
              "address1": "391A Orchard Rd, B2-01-1 Takashimaya, Singapore 238872",
              "lat": 1.3028787,
              "lng": 103.8317915
            },
            {
              "title": "CS Fresh Gold Paragon",
              "address1": "290 Orchard Rd, B1-21/22 Paragon, Singapore 238859",
              "lat": 1.3036325,
              "lng": 103.83321963
            },
            {
              "title": "Cold Storage Claymore Connect",
              "address1": "442, Orchard Road, B1 - 01 to 11 Orchard Hotel, Singapore 238879",
              "lat": 1.3079719,
              "lng": 103.8234876
            },
            {
              "title": "CS Fresh Great World",
              "address1": "1 Kim Seng Promenade, #B1 - 139, Singapore 237994",
              "lat": 1.2942055,
              "lng": 103.8294615
            },
            {
              "title": "CS Fresh Gold Tanglin Mall",
              "address1": "163 Tanglin Rd, B1-101/102/103/104 Tanglin Mall, Singapore 247933",
              "lat": 1.3050787,
              "lng": 103.8216772
            },
            {
              "title": "CS Fresh United Square",
              "address1": "101 Thomson Rd, #B1 - 52, Singapore 307591",
              "lat": 1.317325,
              "lng": 103.8409649
            },
            {
              "title": "Cold Storage Novena Square",
              "address1": "238 Thomson Rd, #01 - 28, Singapore 307683",
              "lat": 1.3202125,
              "lng": 103.8414632
            },
            {
              "title": "CS Fresh Bugis Junction",
              "address1": "200 Victoria Street, #B1-17/18, Bugis Junction, Singapore 188024",
              "lat": 1.2998184,
              "lng": 103.8533548
            },
            {
              "title": "CS Fresh Raffles City",
              "address1": "252 North Bridge Rd #B1-01 Raffles City Shopping Centre, Singapore 179103",
              "lat": 1.2933477,
              "lng": 103.8504035
            },
            {
              "title": "CS Fresh UE Square",
              "address1": "81 Clemenceau Ave, #02-18 UE Square, Singapore 239917",
              "lat": 1.2950226,
              "lng": 103.8406177
            },
            {
              "title": "CS Fresh New Bahru",
              "address1": "46 Kim Yam Rd, #01-09, Singapore 239351",
              "lat": 1.2928106,
              "lng": 103.8361189
            },
            {
              "title": "Cold Storage Harbourfront Centre",
              "address1": "1 Maritime Square, #01-48 to 50, Singapore 099253",
              "lat": 1.2640112,
              "lng": 103.8152497
            },
            {
              "title": "Cold Storage Suntec City",
              "address1": "3 Temasek Boulevard, Mall, B1-154/155/156 Suntec City, 038983",
              "lat": 1.2948982,
              "lng": 103.8572779
            },
            {
              "title": "Cold Storage Sentosa Cove",
              "address1": "1 Cove Ave, #02-07/10 Sentosa Arrival Plaza, 098537",
              "lat": 1.2469797,
              "lng": 103.8371153
            },
            {
              "title": "Cold Storage Tampines 1",
              "address1": "10 Tampines Central 1, B1-01/02, Singapore 529536",
              "lat": 1.3542468,
              "lng": 103.9427722
            },
            {
              "title": "CS Fresh Parkway Parade",
              "address1": "80 Marine Parade Rd, #B1-84B Parkway Parade, Singapore 449269",
              "lat": 1.302122,
              "lng": 103.9029934
            },
            {
              "title": "CS Fresh i12 Katong",
              "address1": "112 East Coast Road B1-01 to 05, 428802",
              "lat": 1.3050694,
              "lng": 103.902569
            },
            {
              "title": "CS Fresh Siglap V",
              "address1": "2 First St, #01-05 Siglap V, Singapore 458278",
              "lat": 1.3128318,
              "lng": 103.9210138
            },
            {
              "title": "Cold Storage Aperia",
              "address1": "12 Kallang Ave, Singapore 339511",
              "lat": 1.3096813,
              "lng": 103.8617212
            },
            {
              "title": "Cold Storage Pasir Ris Mall",
              "address1": "7 Pasir Ris Central, B1-11, Singapore 519612",
              "lat": 1.3722986,
              "lng": 103.9469081
            },
            {
              "title": "Cold Storage Heartland Mall",
              "address1": "205 Hougang St 21, #01 - 133 / 135, Singapore 530205",
              "lat": 1.3593595,
              "lng": 103.8825033
            },
            {
              "title": "Cold Storage Compass One",
              "address1": "1 Sengkang Square, #B1-25, Singapore 545078",
              "lat": 1.3917919,
              "lng": 103.8923348
            },
            {
              "title": "CS Fresh Greenwich V",
              "address1": "1 Seletar Rd, #01-11 Greenwich V, Singapore 807011",
              "lat": 1.3875427,
              "lng": 103.8667828
            },
            {
              "title": "Cold Storage Nex",
              "address1": "23 Serangoon Central, #B2-44/45, Singapore 556083",
              "lat": 1.3508194,
              "lng": 103.8699657
            },
            {
              "title": "Cold Storage Fusionopolis",
              "address1": "1 Fusionopolis Wy, B2-03 One North Connexis, Singapore 138632",
              "lat": 1.2989175,
              "lng": 103.7828852
            },
            {
              "title": "CS Fresh Holland Shopping Centre",
              "address1": "211 Holland Ave, #01-02,04,05 Holland Shopping Ctr, Singapore 278967",
              "lat": 1.3108112,
              "lng": 103.7920954
            },
            {
              "title": "Cold Storage Guthrie House",
              "address1": "1 Fifth Ave., #01-05 Guthrie House, Singapore 268802",
              "lat": 1.3307171,
              "lng": 103.7928659
            },
            {
              "title": "CS Fresh Hillview HillV2",
              "address1": "4 Hillview Rise, #02 - 07, Singapore 667979",
              "lat": 1.3637263,
              "lng": 103.7620455
            },
            {
              "title": "Cold Storage The Rail Mall",
              "address1": "468 Upper Bukit Timah Rd, #464, Singapore 678077",
              "lat": 1.3601902,
              "lng": 103.7650089
            },
            {
              "title": "Cold Storage West Mall",
              "address1": "1 Bukit Batok Central Link, #B1-01 West Mall, Singapore 658713",
              "lat": 1.34500656,
              "lng": 103.7466427
            },
            {
              "title": "Cold Storage Jelita",
              "address1": "293 Holland Road #01-01 Jelita Shopping Centre, 293 Holland Rd, 278628",
              "lat": 1.3176601,
              "lng": 103.7833226
            },
            {
              "title": "Cold Storage West Coast Plaza",
              "address1": "154 W Coast Rd, #B1-19, Singapore 127371",
              "lat": 1.303894,
              "lng": 103.7635845
            },
            {
              "title": "CS Fresh One Holland Village",
              "address1": "7 Holland Vlg Wy, #01-16, Singapore 275748",
              "lat": 1.3114782,
              "lng": 103.791142
            },
            {
              "title": "CS Fresh Chancery Court",
              "address1": "36H Dunearn Rd, #01-44, Singapore 309433",
              "lat": 1.3174034,
              "lng": 103.8335827
            },
            {
              "title": "Cold Storage Anchorpoint",
              "address1": "370 Alexandra Road B1-03 to 10, 370 Alexandra Rd, #B1-03 to 07, 159953",
              "lat": 1.2889235,
              "lng": 103.8024763
            },
            {
              "title": "CS Fresh The Star Vista",
              "address1": "1 Vista Exchange Green #B1-02&35/36, The Star Vista, 138617",
              "lat": 1.3067454,
              "lng": 103.7856123
            },
            {
              "title": "Jasons Deli Ion Orchard",
              "address1": "2 Orchard Turn, ION Orchard, #B4-01, 238801",
              "lat": 1.3039361,
              "lng": 103.829349
            },
            {
              "title": "Jasons Deli Marina Bay Sands",
              "address1": "2 Bayfront Ave, #01-29, Singapore 018972",
              "lat": 1.2845813,
              "lng": 103.8576081
            },
            {
              "title": "Jasons Deli Marina Bay Link Mall",
              "address1": "8A Marina Blvd, #B2-44/45/48/50, Singapore 018984",
              "lat": 1.2803908,
              "lng": 103.8516487
            },
            {
              "title": "Alexandra Hospital Central Pharmacy",
              "address1": "378 Alexandra Rd, Alexandra Hospital, Level 1, Singapore 159964",
              "lat": 1.2858322,
              "lng": 103.7981976
            },
            {
              "title": "NUH Health & U G01-11",
              "address1": "5 Lower Kent Ridge Road, NUH Main Building, Level 1 #01-11 Zone G, Singapore 119074",
              "lat": 1.2941151,
              "lng": 103.7810536
            },
            {
              "title": "NUH Health & U Main Building Pharmacy",
              "address1": "5 Lower Kent Ridge Road, NUH Main Building Pharmacy, Zone F, Level 1, Singapore 119074",
              "lat": 1.2941151,
              "lng": 103.7810536
            },
            {
              "title": "NUH Health & U Medical Centre (B01-31)",
              "address1": "5 Lower Kent Ridge Road, NUH Medical Centre Zone B Level 1, #01-31, Singapore 119074",
              "lat": 1.2941151,
              "lng": 103.7810536
            },
            {
              "title": "NUH Health & U Medical Centre Pharmacy",
              "address1": "5 Lower Kent Ridge Road, NUH Medical Centre Pharmacy, Zone B, Level 3, Singapore 119074",
              "lat": 1.2941151,
              "lng": 103.7810536
            },
            {
              "title": "Woodlands Health Campus Pharmacy",
              "address1": "17 Woodlands Drive 17, Medical Centre Block, Basement 1, Singapore 737628",
              "lat": 1.4252013,
              "lng": 103.7915612
            },
            {
              "title": "Mount Alvernia Retail Pharmacy",
              "address1": "820 Thomson Rd, Singapore 574623",
              "lat": 1.3416368,
              "lng": 103.8346835
            },
            {
              "title": "Ryan's Grocery Great World",
              "address1": "1 Kim Seng Promenade, #B1-144/145, Singapore 237994",
              "lat": 1.293984,
              "lng": 103.8295077
            }
    ];

  function initMap() {
    map = new google.maps.Map(document.getElementById("map"), {
        center: { lat: 1.3521, lng: 103.8198 }, // Singapore default center
        zoom: 12
    });

    updateLocationList(locations);
}

// Function to update the location list and map markers
function updateLocationList(filteredLocations) {
    $("#locationList").empty(); // Clear list
    markers.forEach(marker => marker.setMap(null)); // Remove old markers
    markers = [];

    filteredLocations.forEach((location, index) => {
        // Create Marker
        var marker = new google.maps.Marker({
            position: { lat: location.lat, lng: location.lng },
            map: map,
            title: location.name
        });

        // Add to markers array
        markers.push(marker);

        // Add to list
        $("#locationList").append(`
            <li class="location-item" data-index="${index}"
                style="padding: 10px; cursor: pointer; border-bottom: 1px solid #ddd; color: black;">
                <span style="color: black;"><b>${location.title}</b></span> <br><br>
                <span style="color: black;">${location.address1}</span> <br>
            </li>
        `);
    });

    // Click event for list items
    $(".location-item").on("click", function () {
        var index = $(this).data("index");
        var selectedLocation = filteredLocations[index];

        map.setCenter({ lat: selectedLocation.lat, lng: selectedLocation.lng });
        map.setZoom(14);
    });
}

// Haversine formula to calculate distance
function getDistance(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of Earth in km
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in km
}

// New function to find and display the nearest locations
function findNearestLocations(lat, lng) {
    let nearestLocations = locations
        .map(loc => ({
            ...loc,
            distance: getDistance(lat, lng, loc.lat, loc.lng)
        }))
        .sort((a, b) => a.distance - b.distance)
        .slice(0, 5); // Take the top 5 nearest locations

    if (nearestLocations.length > 0) {
        updateLocationList(nearestLocations);
        map.setCenter({ lat: lat, lng: lng });
        map.setZoom(13);
        // NEW LINE: Update the message to show success
        $("#error").text("Showing nearest locations.").show();
    } else {
        $("#error").text("No nearby locations found.").show();
        updateLocationList([]);
    }
}

// Get coordinates from any address/city using Google Maps Geocoder
function getCoordinates(address, callback) {
    let geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: address }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
            let lat = results[0].geometry.location.lat();
            let lng = results[0].geometry.location.lng();
            callback(lat, lng);
        } else {
            // This message will still show if the Google Geocoder API fails to find the location
            // $("#error").text("Location not found. Please try a different search.").show();
        }
    });
}

$(document).ready(function () {
    $("#searchBox").on("keyup", function () {
        $("#error").text("");
        var searchTerm = $(this).val().trim().toLowerCase();

        if (searchTerm.length === 0) {
            updateLocationList(locations);
            if ($(window).width() <= 767) $("#locationList").hide();
            return;
        }

        if (/^\d{5,6}$/.test(searchTerm)) { // ZIP Code Search
            let matchingLocations = locations.filter(loc => loc.zipCode && loc.zipCode.toLowerCase() === searchTerm);
            if (matchingLocations.length > 0) {
                updateLocationList(matchingLocations);
                map.setCenter({ lat: matchingLocations[0].lat, lng: matchingLocations[0].lng });
                map.setZoom(13);
            } else {
                getCoordinates(searchTerm, function (searchLat, searchLng) {
                    findNearestLocations(searchLat, searchLng);
                });
            }
        } else { // Name or Address Search
            let filteredLocations = locations.filter(loc =>
                loc.title.toLowerCase().includes(searchTerm) ||
                loc.address1.toLowerCase().includes(searchTerm)
            );

            if (filteredLocations.length > 0) {
                updateLocationList(filteredLocations);
                if ($(window).width() <= 767) $("#locationList").show();
            } else {
                getCoordinates(searchTerm, function (searchLat, searchLng) {
                    findNearestLocations(searchLat, searchLng);
                });
            }
        }
    });
});